// extracted by mini-css-extract-plugin
export default {"rankValue":"RankDisplay_rankValue__BTI7G","currentRank":"RankDisplay_currentRank__RcCKE","separator":"RankDisplay_separator__XNopa","totalRanks":"RankDisplay_totalRanks__PBMTH"};